<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    properties: {
      type: Object,
      default: () => ({}),
    },
  },
  inheritAttrs: true,
};
</script>
